import React from 'react';

import {

  useNodesState,
  useEdgesState,
  Node,
  Edge,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { PhoneCall } from 'lucide-react';
import ProjectCaseStudy from '../components/ProjectCaseStudy';

const initialNodes: Node[] = [
  {
    id: '1',
    type: 'input',
    data: { label: 'Incoming Customer Call' },
    position: { x: 50, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '2',
    data: { label: 'VAPI Voice AI Greeting' },
    position: { x: 250, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '3',
    data: { label: 'GPT-4.1 Qualification' },
    position: { x: 450, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '4',
    data: { label: 'Appointment Scheduling' },
    position: { x: 650, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '5',
    data: { label: 'Save to GHL CRM' },
    position: { x: 150, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '6',
    data: { label: 'Trigger n8n Workflow' },
    position: { x: 350, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '7',
    data: { label: 'Store in Supabase' },
    position: { x: 550, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '8',
    data: { label: 'Schedule Follow-up' },
    position: { x: 250, y: 500 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '9',
    type: 'output',
    data: { label: 'Customer Journey Complete' },
    position: { x: 450, y: 500 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
];

const initialEdges: Edge[] = [
  { id: 'e1-2', source: '1', target: '2', animated: true },
  { id: 'e2-3', source: '2', target: '3', animated: true },
  { id: 'e3-4', source: '3', target: '4', animated: true },
  { id: 'e4-5', source: '4', target: '5', animated: true },
  { id: 'e4-6', source: '4', target: '6', animated: true },
  { id: 'e4-7', source: '4', target: '7', animated: true },
  { id: 'e6-8', source: '6', target: '8', animated: true },
  { id: 'e7-8', source: '7', target: '8', animated: true },
  { id: 'e8-9', source: '8', target: '9', animated: true },
];

const ProjectSix = () => {
  const [nodes, , onNodesChange] = useNodesState(initialNodes);
  const [edges, , onEdgesChange] = useEdgesState(initialEdges);

  return (
    <ProjectCaseStudy
      title="Voice AI Appointment System"
      tagline="An AI voice agent that books, reschedules, and follows up — end to end."
      icon={<PhoneCall className="w-7 h-7" />}
      context="A service business was losing bookings to missed calls and manual scheduling. Routine calls were eating staff time."
      built="A VAPI voice agent that handles calls naturally: qualifies intent, books appointments into GHL CRM, stores records in Supabase, and triggers n8n workflows for confirmations and follow-ups."
      stack={['VAPI', 'GHL CRM', 'Supabase', 'n8n', 'GPT-4.1']}
      highlights={['Natural voice booking', 'CRM stays in sync', 'Automated follow-up journeys']}
      nodes={nodes}
      edges={edges}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
    />
  );
};

export default ProjectSix;